import { render, staticRenderFns } from "./email-link.vue?vue&type=template&id=4957ad8c&"
import script from "./email-link.vue?vue&type=script&lang=js&"
export * from "./email-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports